import { useState } from "react";
import { AnimatePresence } from "framer-motion";
import { Page } from "@/components/Reveal";
import QuickView from "@/components/QuickView";
import Marquee from "@/components/Marquee";
import Hero from "@/components/home/Hero";
import CategoryCards from "@/components/home/CategoryCards";
import CapsuleBanners from "@/components/home/CapsuleBanners";
import TabsSection from "@/components/home/TabsSection";
import Philosophy from "@/components/home/Philosophy";
import HotDeals from "@/components/home/HotDeals";
import InstagramFeedStrip from "@/components/home/InstagramFeedStrip";
import JournalSection from "@/components/home/JournalSection";
import Newsletter from "@/components/home/Newsletter";

export default function Home() {
    const [quick, setQuick] = useState(null);
    return (
        <Page>
            <Hero />
            <Marquee
                items={[
                    "Lifetime Stitch & Tear Warranty",
                    "Woven in India",
                    "Slow-Made, Worn Daily",
                    "Limited Editions Only",
                    "Premium Selvedge Denim",
                    "Complimentary Shipping Across India",
                ]}
            />
            <CategoryCards />
            <CapsuleBanners />
            <TabsSection onQuickView={setQuick} />
            <Philosophy />
            <HotDeals />
            <InstagramFeedStrip />
            <JournalSection />
            <Newsletter />
            <AnimatePresence>
                {quick && <QuickView p={quick} onClose={() => setQuick(null)} />}
            </AnimatePresence>
        </Page>
    );
}
